import { usePipelineContext } from '@/context/pipelineContext';
import { FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import React, { useMemo } from 'react';
import { NumericFormat } from 'react-number-format';

const BrokerageNBStages = ({ canEdit = true }) => {
	const { values, setFieldValue } = useFormikContext();
	const { active } = usePipelineContext();

	const nbStages = useMemo(() => {
		const stages = (active ?? []).filter(
			(s) =>
				typeof s === 'object' &&
				s.pipelineId === process.env.REACT_APP_PIPELINE_NEW_BUSINESS &&
				!s.isEndorsement,
		);
		return [...new Map(stages.map((stage) => [stage.id, stage])).values()];
	}, [active]);

	if (!nbStages.length) return null;

	return (
		<>
			<Grid size={12}>
				<Typography variant='form_label' fontSize='16px'>
					New business KPI conversion rates
				</Typography>
			</Grid>

			{nbStages.map((stage) => (
				<Grid size={6} key={stage.id}>
					<FormLabel variant='body2'>{stage.label}</FormLabel>
					<NumericFormat
						customInput={TextField}
						value={values?.conversionRates?.[stage.id] ?? ''}
						disabled={!canEdit}
						onValueChange={({ value }) => {
							setFieldValue(
								`conversionRates.${stage.id}`,
								value ? Number(value) : '',
							);
						}}
						suffix='%'
						decimalScale={2}
						allowNegative={false}
						fullWidth
						isAllowed={({ floatValue }) =>
							floatValue === undefined ? true : floatValue >= 1 && floatValue <= 100
						}
					/>
				</Grid>
			))}
		</>
	);
};

export default BrokerageNBStages;
